import SigniteButton from '../../ui-elements/signite-button/signiteButton';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import ClientCandidateService from '../../../services/client-services/clientCandidateService';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import Loader from 'react-spinner-loader';
import { CandidatesTable } from './candidate-listing-table/candidatesTables';
import { CandidateService } from '../../../services/candidateService';
import { prepareCandidateData } from '../../../utils/dataTableUtilsAdmin';
import { Form, InputGroup } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { faPlusCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import useTrackPreviousPath from '../trackPreviousPath/useTrackPreviousPath';
import { decodeJWT } from '../../../services/candidateService';
import { MasterDataService } from '../../../services/masterDataService';
import CuratePopup from './candiate-info-nav/curatePopup';

const CandidateListing = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isRestoringRef = useRef(false);
  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  const queryClient = new QueryClient();
  const [loader, setLoader] = useState(false);
  const [candidateId, setCandidateId] = useState('')
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [designation, setDesignation] = useState('');
  const [yearsOfExpMin, setYearsOfExpMin] = useState(null);
  const [yearsOfExpMax, setYearsOfExpMax] = useState(null);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [industry, setIndustry] = useState('');
  const [subcategory, setSubCategory] = useState('');
  const [ctcMin, setCtcMin] = useState(null);
  const [ctcMax, setCtcMax] = useState(null);
  const [tableResetKey, setTableResetKey] = useState(0);
  const [updatedCandidateId, setUpdatedCandidateId] = useState('');
  const [updatedFirstName, setUpdatedFirstName] = useState('');
  const [updatedLastName, setUpdatedLastName] = useState('');
  const [updatedSearchLocation, setUpdatedSearchLocation] = useState('');
  const [updatedDesignation, setUpdatedDesignation] = useState('');
  const [updatedYearsOfExpMin, setUpdatedYearsOfExpMin] = useState(null);
  const [updatedYearsOfExpMax, setUpdatedYearsOfExpMax] = useState(null);
  const [updatedIndustry, setUpdatedIndustry] = useState('');
  const [updatedSubCategory, setUpdatedSubCategory] = useState('');

  const [updatedCtcMin, setUpdatedCtcMin] = useState(null);
  const [updatedCtcMax, setUpdatedCtcMax] = useState(null);
  const [cityOptions, setCityOptions] = useState([]);
  const [industryOptions, setIndustryOptions] = useState([]);
  const [industrySubcategories, setIndustrySubcategories] = useState([]);
  const [selectedIndustryId, setSelectedIndustryId] = useState(null);

  // Function & Function Subcategory
  const [functions, setFunctions] = useState([]);
  const [functionSubcategories, setFunctionSubcategories] = useState([]);
  const [selectedFunctionId, setSelectedFunctionId] = useState(null);
  const [selectedFunction, setSelectedFunction] = useState('');
  const [selectedFunctionSubcategory, setSelectedFunctionSubcategory] = useState('');

  // Updated values
  const [updatedFunction, setUpdatedFunction] = useState('');
  const [updatedFunctionSubcategory, setUpdatedFunctionSubcategory] = useState('');

  // Function & Industry states
  const [currentFunction, setCurrentFunction] = useState('');
  const [currentFunctionSub, setCurrentFunctionSub] = useState('');
  const [selectedFunctionPairs, setSelectedFunctionPairs] = useState([]);
  const [showFunctionPopup, setShowFunctionPopup] = useState(false);

  const [currentIndustry, setCurrentIndustry] = useState('');
  const [currentSubCategory, setCurrentSubCategory] = useState('');
  const [currentSubCategories, setCurrentSubCategories] = useState([]);
  const [selectedIndustryPairs, setSelectedIndustryPairs] = useState([]);
  const [showIndustryPopup, setShowIndustryPopup] = useState(false);
  const isPopupOpen = showFunctionPopup || showIndustryPopup;


  const selectedFunctionPairsRef = useRef(selectedFunctionPairs);
  const selectedIndustryPairsRef = useRef(selectedIndustryPairs);

  useEffect(() => {
    selectedFunctionPairsRef.current = selectedFunctionPairs;
  }, [selectedFunctionPairs]);

  useEffect(() => {
    selectedIndustryPairsRef.current = selectedIndustryPairs;
  }, [selectedIndustryPairs]);


  useTrackPreviousPath();

  const [showCurateModal, setShowCurateModal] = useState(false);
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);

  const handleCurateClick = (candidateId) => {
    setSelectedCandidateId(candidateId);
    setShowCurateModal(true);
  };

  const [candiateTableData, setCandidateTableData] = useState({ columns: [], data: [] });
  const newCandidate = () => {
    window.location = '/candidate/candidate-personal-info';
  };

  const addFunctionPair = () => {
    if (!currentFunction) return;

    const functionName = functions.find(
      f => f.id == currentFunction
    )?.function;

    const subName = functionSubcategories.find(
      s => s.id == currentFunctionSub
    )?.subcategory;

    const exists = selectedFunctionPairs.some(
      f =>
        f.functionName === functionName &&
        (f.subcategory || '') === (subName || '')
    );

    if (exists) return;

    const updated = [
      ...selectedFunctionPairs,
      {
        functionName,
        subcategory: subName || null
      }
    ];

    setSelectedFunctionPairs(updated);

    setCurrentFunction('');
    setCurrentFunctionSub('');
    setFunctionSubcategories([]);
  };

  const addIndustryPair = () => {
    if (!currentIndustry) return;

    const industryName = industryOptions.find(
      i => i.id == currentIndustry
    )?.industrySector;

    const subCategoryName = currentSubCategories.find(
      sc => sc.id == currentSubCategory
    )?.subcategory;

    const exists = selectedIndustryPairs.some(
      i =>
        i.industryName === industryName &&
        (i.subCategoryName || '') === (subCategoryName || '')
    );

    if (exists) return;

    const updated = [
      ...selectedIndustryPairs,
      {
        industryId: currentIndustry,
        subCategoryId: currentSubCategory || null,
        industryName,
        subCategoryName: subCategoryName || null
      }
    ];

    setSelectedIndustryPairs(updated);

    setCurrentIndustry('');
    setCurrentSubCategory('');
    setCurrentSubCategories([]);
  };


  const removeFunctionPair = (idx, { silent = false } = {}) => {
    const updated = selectedFunctionPairs.filter((_, i) => i !== idx);
    setSelectedFunctionPairs(updated);

    selectedFunctionPairsRef.current = updated;

    if (!silent && !isPopupOpen) {
      const updatedFunctionNames = updated.map(f => f.functionName);
      const updatedFunctionSubcategories = updated.map(f => f.subcategory || '');

      triggerLiveSearch(
        {
          firstName,
          lastName,
          locations: selectedLocations,
          designation,
          candidateId,
          yearsOfExpMin,
          yearsOfExpMax,
          industry: selectedIndustryPairs.map(i => i.industryName),
          subcategory: selectedIndustryPairs.map(i => i.subCategoryName || ''),
          selectedFunction: updatedFunctionNames,
          selectedFunctionSubcategory: updatedFunctionSubcategories,
          ctcMin,
          ctcMax,
        },
        updated,
        selectedIndustryPairs
      );
    }
  };


  const removeIndustryPair = (idx, { silent = false } = {}) => {
    const updated = selectedIndustryPairs.filter((_, i) => i !== idx);
    setSelectedIndustryPairs(updated);

    selectedIndustryPairsRef.current = updated;

    if (!silent && !isPopupOpen) {
      const updatedIndustryNames = updated.map(i => i.industryName);
      const updatedSubCategories = updated.map(i => i.subCategoryName || '');

      triggerLiveSearch(
        {
          firstName,
          lastName,
          locations: selectedLocations,
          designation,
          candidateId,
          yearsOfExpMin,
          yearsOfExpMax,
          industry: updatedIndustryNames,
          subcategory: updatedSubCategories,
          selectedFunction: selectedFunctionPairs.map(f => f.functionName),
          selectedFunctionSubcategory: selectedFunctionPairs.map(f => f.subcategory),
          ctcMin,
          ctcMax,
        },
        selectedFunctionPairs,
        updated
      );
    }
  };




  const handleAddAndCloseFunction = () => {
    addFunctionPair();
    setShowFunctionPopup(false);
    setCurrentFunction('');
    setCurrentFunctionSub('');
    setFunctionSubcategories([]);
  };

  const handleAddMoreFunction = () => {
    addFunctionPair();
    setCurrentFunction('');
    setCurrentFunctionSub('');
    setFunctionSubcategories([]);
  };

  const handleAddAndCloseIndustry = () => {
    addIndustryPair();
    setShowIndustryPopup(false);
    setCurrentIndustry('');
    setCurrentSubCategory('');
    setCurrentSubCategories([]);
  };

  const handleAddMoreIndustry = () => {
    addIndustryPair();
    setCurrentIndustry('');
    setCurrentSubCategory('');
    setCurrentSubCategories([]);
  };

  // Function Subcategories
  const handleFunctionChangePopup = async (id) => {
    setCurrentFunction(id);
    setCurrentFunctionSub('');

    try {
      const res = await MasterDataService.getFunctionSubcategories(id);
      setFunctionSubcategories(res.data || []);
    } catch {
      setFunctionSubcategories([]);
    }
  };


  // Industry Subcategories
  const handleIndustryChangePopup = async (industryId) => {
    setCurrentIndustry(industryId);
    setCurrentSubCategory('');

    try {
      const res = await MasterDataService.getIndustrySubcategories(industryId);
      setCurrentSubCategories(res.data || []);
    } catch {
      setCurrentSubCategories([]);
    }
  };


  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [citiesRes, industriesRes, functionsRes] = await Promise.all([
          MasterDataService.getAllCities(),
          MasterDataService.getAllIndustrySectors(),
          MasterDataService.getAllFunctions(),
        ]);

        const cities = citiesRes?.data?.map((city) => city.cityName || city.name || city) || [];
        const rawIndustries = industriesRes?.data || [];
        const industries = rawIndustries.map((ind) => {
          if (typeof ind === 'string') {
            return { id: null, industrySector: ind };
          }
          // handle response shapes
          const industrySector =
            ind.industrySector || ind.industrySectorName || ind.name || '';
          const id = ind.id ?? null;
          return { id, industrySector };
        });

        setCityOptions(cities);
        setIndustryOptions(industries);
        setFunctions(functionsRes?.data || []);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };

    fetchDropdownData();
  }, []);


  const handleFunctionChange = async (e) => {
    const value = e.target.value;
    setSelectedFunction(value);
    setSelectedFunctionSubcategory('');
    setFunctionSubcategories([]);
    setSelectedFunctionId(null);
    if (!value) {
      setUpdatedFunction('');
      setUpdatedFunctionSubcategory('');
      return;
    }
    if (!value) return;

    const match = functions.find(
      (fn) => fn.function.toLowerCase() === value.toLowerCase()
    );

    if (!match) return;

    setSelectedFunctionId(match.id);

    try {
      const res = await MasterDataService.getFunctionSubcategories(match.id);
      setFunctionSubcategories(res.data || []);
    } catch (err) {
      console.error('Failed to load function subcategories', err);
    }
  };

  useEffect(() => {
    const shouldRestore = sessionStorage.getItem('fromCandidateInfo') === 'true';

    if (shouldRestore) {
      const savedPagination = sessionStorage.getItem('candidatePagination-listing');
      if (savedPagination) {
        sessionStorage.setItem('restorePagination', 'true');
      }

      isRestoringRef.current = true;
      const savedState = sessionStorage.getItem('candidateSearchState');
      sessionStorage.removeItem('fromCandidateInfo');

      if (savedState) {
        const parsed = JSON.parse(savedState);
        setFirstName(parsed.firstName || '');
        setLastName(parsed.lastName || '');
        setSelectedLocations(parsed.locations || []);
        setDesignation(parsed.designation || '');
        setCandidateId(parsed.candidateId || '');
        setYearsOfExpMin(parsed.yearsOfExpMin ?? null);
        setYearsOfExpMax(parsed.yearsOfExpMax ?? null);
        setIndustry(parsed.industry || '');
        setSubCategory(parsed.subcategory || '');
        setCtcMin(parsed.ctcMin ?? null);
        setCtcMax(parsed.ctcMax ?? null);

        setSelectedFunction(parsed.function || '');
        setSelectedFunctionSubcategory(parsed.functionSubcategory || '');

        setUpdatedFirstName(parsed.firstName || '');
        setUpdatedLastName(parsed.lastName || '');
        setUpdatedSearchLocation((parsed.locations || []).join(', ')); // updated for display

        setUpdatedDesignation(parsed.designation || '');
        setUpdatedCandidateId(parsed.candidateId || '');
        setUpdatedYearsOfExpMin(parsed.yearsOfExpMin ?? null);
        setUpdatedYearsOfExpMax(parsed.yearsOfExpMax ?? null);
        setUpdatedIndustry(parsed.industry || '');
        setUpdatedSubCategory(parsed.subcategory || '');
        setUpdatedCtcMin(parsed.ctcMin ?? null);
        setUpdatedCtcMax(parsed.ctcMax ?? null);
        setUpdatedFunction(parsed.function || '');
        setUpdatedFunctionSubcategory(parsed.functionSubcategory || '');
      }

      if (savedPagination) {
        const parsed = JSON.parse(savedPagination);
        sessionStorage.setItem('candidatePagination-listing', JSON.stringify(parsed));
        setTableResetKey((prev) => prev + 1);
      }

      setTimeout(() => {
        isRestoringRef.current = false;
      }, 0);
    }
    else {
      const hasExistingSearch = sessionStorage.getItem('candidateSearchState');
      const hasPagination = sessionStorage.getItem('candidatePagination-listing');

      if (!hasExistingSearch) sessionStorage.removeItem('candidateSearchState');
      if (!hasPagination) sessionStorage.removeItem('candidatePagination-listing');
    }

  }, []);

  useEffect(() => {
    if (!industry || !industryOptions || industryOptions.length === 0) {
      setIndustrySubcategories([]);
      setSelectedIndustryId(null);
      return;
    }

    const match = industryOptions.find(
      (sec) => sec.industrySector?.toLowerCase() === (industry || '').toLowerCase()
    );

    if (!match || !match.id) {
      setIndustrySubcategories([]);
      setSelectedIndustryId(null);
      return;
    }

    const id = match.id;
    setSelectedIndustryId(id);

    MasterDataService.getIndustrySubcategories(id)
      .then((res) => {
        setIndustrySubcategories(res.data || []);
      })
      .catch((err) => {
        console.error('Failed loading subcategories on init:', err);
        setIndustrySubcategories([]);
      });
  }, [industry, industryOptions]);

  const searchCandidate = () => {
    const searchState = {
      firstName,
      lastName,
      locations: selectedLocations,
      designation,
      candidateId,
      yearsOfExpMin,
      yearsOfExpMax,
      industry,
      subcategory,
      ctcMin,
      ctcMax,
      function: selectedFunction,
      functionSubcategory: selectedFunctionSubcategory,
    };
    sessionStorage.setItem('candidateSearchState', JSON.stringify(searchState));
    sessionStorage.setItem(
      'candidatePagination-listing',
      JSON.stringify({ pageIndex: 0, pageSize: 10 })
    );

    setUpdatedFirstName(firstName);
    setUpdatedLastName(lastName);
    setUpdatedSearchLocation(selectedLocations.join(', '));
    setUpdatedDesignation(designation);
    setUpdatedCandidateId(candidateId);
    setUpdatedYearsOfExpMin(yearsOfExpMin);
    setUpdatedYearsOfExpMax(yearsOfExpMax);
    setUpdatedIndustry(industry);
    setUpdatedSubCategory(subcategory);
    setUpdatedFunction(selectedFunction);
    setUpdatedFunctionSubcategory(selectedFunctionSubcategory);

    setUpdatedCtcMin(ctcMin);
    setUpdatedCtcMax(ctcMax);
    setTableResetKey((prev) => prev + 1);

  };


  const triggerLiveSearch = (
    updatedSearchState = {
      firstName,
      lastName,
      locations: selectedLocations,
      designation,
      candidateId,
      yearsOfExpMin,
      yearsOfExpMax,
      industry,
      subcategory,
      selectedFunction: selectedFunctionPairs.map(f => f.functionName),
      selectedFunctionSubcategory: selectedFunctionPairs.map(f => f.subcategory),
      ctcMin,
      ctcMax,
    }
  ) => {
    if (!updatedSearchState || typeof updatedSearchState !== 'object') return;

    sessionStorage.setItem(
      'candidateSearchState',
      JSON.stringify(updatedSearchState)
    );

    setUpdatedFirstName(updatedSearchState.firstName || '');
    setUpdatedLastName(updatedSearchState.lastName || '');
    setUpdatedSearchLocation((updatedSearchState.locations || []).join(', '));
    setUpdatedDesignation(updatedSearchState.designation || '');
    setUpdatedCandidateId(updatedSearchState.candidateId || '');
    setUpdatedYearsOfExpMin(updatedSearchState.yearsOfExpMin ?? null);
    setUpdatedYearsOfExpMax(updatedSearchState.yearsOfExpMax ?? null);
    setUpdatedIndustry(updatedSearchState.industry || '');
    setUpdatedSubCategory(updatedSearchState.subcategory || '');
    setUpdatedFunction(updatedSearchState.selectedFunction || []);
    setUpdatedFunctionSubcategory(updatedSearchState.selectedFunctionSubcategory || []);
    setUpdatedCtcMin(updatedSearchState.ctcMin ?? null);
    setUpdatedCtcMax(updatedSearchState.ctcMax ?? null);
  };


  const previousValuesRef = useRef({
    firstName,
    lastName,
    selectedLocations,
    designation,
    candidateId,
    yearsOfExpMin,
    yearsOfExpMax,
    industry,
    selectedFunction,
    selectedFunctionSubcategory,
    ctcMin,
    ctcMax,
    subcategory,
  });

  useEffect(() => {
    if (isRestoringRef.current) return;

    const prev = previousValuesRef.current;

    const isClearingAnyField =
      (prev.firstName && !firstName) ||
      (prev.lastName && !lastName) ||
      (prev.selectedLocations && prev.selectedLocations.length && selectedLocations.length === 0) ||
      (prev.designation && !designation) ||
      (prev.candidateId && !candidateId) ||
      (prev.yearsOfExpMin && !yearsOfExpMin) ||
      (prev.yearsOfExpMax && !yearsOfExpMax) ||
      (prev.industry && !industry) ||
      (prev.ctcMin && !ctcMin) ||
      (prev.ctcMax && !ctcMax) ||
      (prev.subcategory && !subcategory) ||
      (prev.selectedFunction && !selectedFunction) ||
      (prev.selectedFunctionSubcategory && !selectedFunctionSubcategory);

    if (isClearingAnyField) {
      triggerLiveSearch();
    }

    previousValuesRef.current = {
      firstName,
      lastName,
      selectedLocations,
      designation,
      candidateId,
      yearsOfExpMin,
      yearsOfExpMax,
      industry,
      ctcMin,
      ctcMax,
      subcategory,
      selectedFunction,
      selectedFunctionSubcategory,
    };
  }, [
    firstName,
    lastName,
    selectedLocations,
    designation,
    candidateId,
    yearsOfExpMin,
    yearsOfExpMax,
    industry,
    ctcMin,
    ctcMax,
    subcategory,
    selectedFunction,
    selectedFunctionSubcategory,
  ]);

  const setSearchField = (event) => {
    const { id, value } = event.target;

    switch (id) {
      case 'candidateId':
        setCandidateId(value);
        break;
      case 'firstName':
        setFirstName(value);
        break;
      case 'lastName':
        setLastName(value);
        break;
      case 'designation':
        setDesignation(value);
        break;
      case 'yearsOfExpMin':
        setYearsOfExpMin(value ? parseInt(value, 10) : null);
        break;
      case 'yearsOfExpMax':
        setYearsOfExpMax(value ? parseInt(value, 10) : null);
        break;
      case 'location':
        if (!value) return;
        if (!selectedLocations.includes(value)) {
          const updated = [...selectedLocations, value];
          setSelectedLocations(updated);
          setUpdatedSearchLocation(updated.join(', '));
        }
        break;
      case 'industry':
        handleIndustryChange(value);
        break;
      case 'ctcMin':
        setCtcMin(value ? parseInt(value, 10) : null);
        break;
      case 'ctcMax':
        setCtcMax(value ? parseInt(value, 10) : null);
        break;
    }
  };

  const handleIndustryChange = async (arg) => {
    const selectedLabel = typeof arg === 'string' ? arg : (arg?.target?.value || '');
    setIndustry(selectedLabel);
    setSubCategory('');
    setIndustrySubcategories([]);
    setSelectedIndustryId(null);

    if (!selectedLabel) {
      return;
    }

    const match = industryOptions.find(
      (sec) => sec.industrySector?.toLowerCase() === selectedLabel?.toLowerCase()
    );

    if (!match || !match.id) {
      return;
    }

    setSelectedIndustryId(match.id);

    try {
      const res = await MasterDataService.getIndustrySubcategories(match.id);
      setIndustrySubcategories(res.data || []);
    } catch (err) {
      console.error('Failed loading subcategories:', err);
      setIndustrySubcategories([]);
    }
  };

  const fetchData = async ({ pageIndex, pageSize }) => {
    setLoader(true);
    try {
      const searchBody = {
        page: pageIndex,
        size: pageSize,
        firstName: updatedFirstName?.trim() || '',
        lastName: updatedLastName?.trim() || '',
        locations: selectedLocations || [],
        candidateId: updatedCandidateId?.trim() || '',
        designation: updatedDesignation?.trim() || '',
        yearsOfExpMin: updatedYearsOfExpMin !== null ? updatedYearsOfExpMin : null,
        yearsOfExpMax: updatedYearsOfExpMax !== null ? updatedYearsOfExpMax : null,
        ctcMin: updatedCtcMin !== null ? updatedCtcMin : null,
        ctcMax: updatedCtcMax !== null ? updatedCtcMax : null,
        industrySubcategories: (selectedIndustryPairsRef.current || []).map(row => ({
          fieldValue: row.industryName,
          subcategory: row.subCategoryName || '',
        })),
        functions: (selectedFunctionPairsRef.current || []).map(f => ({
          fieldValue: f.functionName,
          subcategory: f.subcategory || '',
        })),
        specialisation: '',
      };


      const response = await ClientCandidateService.osInternalUserSearch(searchBody);
      const retData = response.data;

      setLoader(false);
      return {
        rows: prepareCandidateData(retData, null, false, false, false, false, handleCurateClick),
        pageCount: retData.pageCount,
      };
    } catch (e) {
      alert('An error occurred while fetching candidates!');
      setLoader(false);
    }
  };

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      searchCandidate();
    }
  };
  const { columns, data } = candiateTableData;
  return (
    <Container fluid>
      <Loader show={loader} type="body" stack="vertical" message="Loading Data" />

      <Row>
        <Card className="p-0">
          <Card.Header className="m-0" style={{ backgroundColor: 'white' }}>
            <Form className="pr">
              <Row className="align-items-center">
                <Col lg={12}></Col>
                <Col xs="auto">
                  <div className="client-search-candidate-input-group mb-2">
                    <span className="client-search-candidate-input-icon">
                      <i className="fas fa-id-badge"></i>
                    </span>
                    <input
                      type="text"
                      className="client-search-candidate-input"
                      id="candidateId"
                      placeholder="Candidate ID"
                      value={candidateId}
                      onChange={(event) => setSearchField(event)}
                      onKeyUp={onKeyUp}
                      spellCheck={false}
                    />
                  </div>
                </Col>

                <Col xs="auto">
                  <div className="client-search-candidate-input-group mb-2">
                    <span className="client-search-candidate-input-icon">
                      <i className="fas fa-user"></i>
                    </span>
                    <input
                      type="text"
                      className="client-search-candidate-input"
                      id="firstName"
                      placeholder="First Name"
                      value={firstName}
                      onChange={(event) => setSearchField(event)}
                      onKeyUp={onKeyUp}
                      spellCheck={false}
                    />
                  </div>
                </Col>

                <Col xs="auto">
                  <div className="client-search-candidate-input-group mb-2">
                    <span className="client-search-candidate-input-icon">
                      <i className="fas fa-user"></i>
                    </span>
                    <input
                      type="text"
                      className="client-search-candidate-input"
                      id="lastName"
                      placeholder="Last Name"
                      value={lastName}
                      onChange={(event) => setSearchField(event)}
                      onKeyUp={onKeyUp}
                      spellCheck={false}
                    />
                  </div>
                </Col>

                <Col xs="auto">
                  <div className="client-search-candidate-input-group mb-2">
                    <span className="client-search-candidate-input-icon">
                      <i className="fas fa-user-tie"></i>
                    </span>
                    <input
                      type="text"
                      className="client-search-candidate-input"
                      id="designation"
                      placeholder="Designation (e.g., CEO, CFO, GM)"
                      value={designation}
                      onChange={(event) => setSearchField(event)}
                      onKeyUp={onKeyUp}
                      spellCheck={false}
                    />
                  </div>
                </Col>

                <Col xs="auto">
                  <div className="client-search-candidate-input-group mb-2">
                    <span className="client-search-candidate-input-icon">
                      <i className="fas fa-clock"></i>
                    </span>
                    <input
                      type="number"
                      className="client-search-candidate-input"
                      id="yearsOfExpMin"
                      placeholder="Exp Min (Years)"
                      value={yearsOfExpMin ?? ''}
                      onChange={(e) =>
                        setYearsOfExpMin(e.target.value ? parseInt(e.target.value, 10) : null)
                      }
                      onKeyUp={onKeyUp}
                      spellCheck={false}
                    />
                  </div>
                </Col>

                <Col xs="auto">
                  <div className="client-search-candidate-input-group mb-2">
                    <span className="client-search-candidate-input-icon">
                      <i className="fas fa-clock"></i>
                    </span>
                    <input
                      type="number"
                      className="client-search-candidate-input"
                      id="yearsOfExpMax"
                      placeholder="Exp Max (Years)"
                      value={yearsOfExpMax ?? ''}
                      onChange={(e) =>
                        setYearsOfExpMax(e.target.value ? parseInt(e.target.value, 10) : null)
                      }
                      onKeyUp={onKeyUp}
                      spellCheck={false}
                    />
                  </div>
                </Col>

                <Col xs="auto">
                  <div style={{ display: "flex", gap: "8px" }}>
                    <div className="client-search-candidate-input-group" style={{ flex: 1 }}>
                      <span className="client-search-candidate-input-icon">
                        <i className="fas fa-industry"></i>
                      </span>
                      <input
                        readOnly
                        className="client-search-candidate-input"
                        placeholder="Industry"
                        value=""
                        onClick={() => setShowIndustryPopup(true)}
                      />
                    </div>
                  </div>

                  <div style={{ marginTop: "6px", display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    {selectedIndustryPairs.map((row, idx) => (
                      <span key={idx} style={{
                        background: "#e8f1ff", padding: "6px 10px", borderRadius: "20px",
                        display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px"
                      }}>
                        {row.industryName}{row.subCategoryName && <> → {row.subCategoryName}</>}
                        <button type='button' onClick={() => removeIndustryPair(idx)} style={{
                          background: "transparent", border: "none", cursor: "pointer", color: "#f35824",
                          fontWeight: "bold", fontSize: "15px",
                        }}>×</button>
                      </span>
                    ))}
                  </div>
                </Col>

                <Col xs="auto">
                  <div style={{ display: "flex", gap: "8px" }}>
                    <div className="client-search-candidate-input-group" style={{ flex: 1 }}>
                      <span className="client-search-candidate-input-icon">
                        <i className="fas fa-briefcase"></i>
                      </span>
                      <input
                        readOnly
                        className="client-search-candidate-input"
                        placeholder="Function"
                        value=""
                        onClick={() => setShowFunctionPopup(true)}
                      />
                    </div>
                  </div>

                  <div style={{ marginTop: "6px", display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    {selectedFunctionPairs.map((f, idx) => (
                      <span key={idx} style={{
                        background: "#e8f1ff", color: '#000', padding: "6px 10px", borderRadius: "20px",
                        display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px", fontWeight: '500'
                      }}>
                        {f.functionName}{f.subcategory && <> → {f.subcategory}</>}
                        <button type='button' onClick={() => removeFunctionPair(idx)} style={{
                          background: "transparent", border: "none", cursor: "pointer", color: "#f35824",
                          fontWeight: "bold", fontSize: "15px",
                        }}>×</button>
                      </span>
                    ))}
                  </div>
                </Col>
                <Col xs="auto">
                  <div className="client-search-candidate-input-group">
                    <span className="client-search-candidate-input-icon">
                      <i className="fas fa-location"></i>
                    </span>
                    <select
                      className="client-search-candidate-input mb-2"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!value) return;
                        if (!selectedLocations.includes(value)) {
                          const updated = [...selectedLocations, value];
                          setSelectedLocations(updated);
                        }
                        e.target.value = "";
                      }}
                      style={{ minWidth: '180px', height: '38px' }}
                    >
                      <option value="">Location</option>
                      {cityOptions.map((city, idx) => (
                        <option key={idx} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div style={{ marginTop: '6px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {selectedLocations.map((loc, idx) => (
                      <span
                        key={idx}
                        style={{
                          background: '#e8f1ff',
                          padding: '6px 10px',
                          borderRadius: '20px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '6px',
                          fontSize: '13px',
                          fontWeight: '500'
                        }}
                      >
                        {loc}
                        <button
                          type="button"
                          onClick={() => {
                            const updated = selectedLocations.filter((_, i) => i !== idx);
                            setSelectedLocations(updated);

                            setUpdatedSearchLocation(updated.join(', '));

                            if (updated.length === 0) {
                              setUpdatedSearchLocation('');
                            }
                          }}
                          style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#f35824',
                            fontWeight: 'bold',
                            fontSize: '15px',
                          }}
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                </Col>


                <Col xs="auto">
                  <div className="client-search-candidate-input-group mb-2">
                    <span className="client-search-candidate-input-icon">
                      <i className="fas fa-money-bill-wave"></i>
                    </span>
                    <input
                      type="number"
                      className="client-search-candidate-input"
                      id="ctcMin"
                      placeholder="CTC Min"
                      value={ctcMin ?? ''}
                      onChange={(event) => setSearchField(event)}
                      onKeyUp={onKeyUp}
                      spellCheck={false}
                    />
                  </div>
                </Col>

                <Col xs="auto">
                  <div className="client-search-candidate-input-group mb-2">
                    <span className="client-search-candidate-input-icon">
                      <i className="fas fa-money-bill-wave"></i>
                    </span>
                    <input
                      type="number"
                      className="client-search-candidate-input"
                      id="ctcMax"
                      placeholder="CTC Max"
                      value={ctcMax ?? ''}
                      onChange={(event) => setSearchField(event)}
                      onKeyUp={onKeyUp}
                      spellCheck={false}
                    />
                  </div>
                </Col>

                <Col xs="auto">
                  <SigniteButton variant={'primary'} className="mb-2 ms-2" onClick={searchCandidate}>
                    Search
                  </SigniteButton>

                  <SigniteButton type="button" variant="primary" className="mb-2 ms-2" onClick={newCandidate}>
                    <FontAwesomeIcon icon={faPlusCircle} size="sm" /> <span>Add Candidate</span>
                  </SigniteButton>
                </Col>
              </Row>
            </Form>
          </Card.Header>
          <Card.Body>
            <QueryClientProvider client={queryClient}>
              <CandidatesTable
                key={tableResetKey}
                tableKey="listing"
                columns={columns}
                fetchData={fetchData}
                candidateId={updatedCandidateId}
                firstName={updatedFirstName}
                lastName={updatedLastName}
                designation={updatedDesignation}
                yearsOfExpMin={updatedYearsOfExpMin}
                yearsOfExpMax={updatedYearsOfExpMax}
                searchLocation={updatedSearchLocation}
                industry={updatedIndustry}
                ctcMin={updatedCtcMin}
                ctcMax={updatedCtcMax}
              />
            </QueryClientProvider>
          </Card.Body>
        </Card>
      </Row>
      {showCurateModal && (
        <CuratePopup
          show={showCurateModal}
          onClose={() => setShowCurateModal(false)}
          candidateId={selectedCandidateId}
        />
      )}
      <Row></Row>
      {showFunctionPopup && (
        <div className="popup-overlay">
          <div className="popup-box">

            <button
              className="popup-close-btn"
              onClick={() => setShowFunctionPopup(false)}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <h5>Select Function</h5>

            <div className="popup-fields-horizontal">
              <select
                className="client-search-candidate-input"
                value={currentFunction}
                onChange={(e) => handleFunctionChangePopup(e.target.value)}
              >
                <option value="">Function</option>
                {functions.map(f => (
                  <option key={f.id} value={f.id}>
                    {f.function}
                  </option>
                ))}
              </select>

              <select
                className="client-search-candidate-input"
                value={currentFunctionSub}
                disabled={!currentFunction}
                onChange={(e) => setCurrentFunctionSub(e.target.value)}
              >
                <option value="">Subcategory</option>
                {functionSubcategories.map(sc => (
                  <option key={sc.id} value={sc.id}>
                    {sc.subcategory}
                  </option>
                ))}
              </select>
            </div>

            {selectedFunctionPairs.length > 0 && (
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px"
                }}
              >
                {selectedFunctionPairs.map((f, idx) => (
                  <span
                    key={idx}
                    style={{
                      background: "#e8f1ff",
                      padding: "6px 10px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px"
                    }}
                  >
                    {f.functionName}
                    {f.subcategory && <> → {f.subcategory}</>}
                    <button
                      type="button"
                      onClick={() => removeFunctionPair(idx, { silent: true })}
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        color: "#f35824",
                        fontWeight: "bold"
                      }}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            )}

            <div className="popup-actions">
              <button onClick={handleAddAndCloseFunction}>Add</button>
              <button onClick={handleAddMoreFunction}>Add More</button>
            </div>

          </div>
        </div>
      )}


      {showIndustryPopup && (
        <div className="popup-overlay">
          <div className="popup-box">

            <button
              className="popup-close-btn"
              onClick={() => setShowIndustryPopup(false)}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <h5>Select Industry</h5>

            <div className="popup-fields-horizontal">
              <select
                className="client-search-candidate-input"
                value={currentIndustry}
                onChange={(e) => handleIndustryChangePopup(e.target.value)}
              >
                <option value="">Industry</option>
                {industryOptions.map(i => (
                  <option key={i.id} value={i.id}>
                    {i.industrySector}
                  </option>
                ))}
              </select>

              <select
                className="client-search-candidate-input"
                value={currentSubCategory}
                disabled={!currentIndustry}
                onChange={(e) => setCurrentSubCategory(e.target.value)}
              >
                <option value="">Subcategory</option>
                {currentSubCategories.map(sc => (
                  <option key={sc.id} value={sc.id}>
                    {sc.subcategory}
                  </option>
                ))}
              </select>
            </div>

            {selectedIndustryPairs.length > 0 && (
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px"
                }}
              >
                {selectedIndustryPairs.map((row, idx) => (
                  <span
                    key={idx}
                    style={{
                      background: "#e8f1ff",
                      padding: "6px 10px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px"
                    }}
                  >
                    {row.industryName}
                    {row.subCategoryName && <> → {row.subCategoryName}</>}
                    <button
                      type="button"
                      onClick={() => removeIndustryPair(idx, { silent: true })}
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        color: "#f35824",
                        fontWeight: "bold"
                      }}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            )}

            <div className="popup-actions">
              <button onClick={handleAddAndCloseIndustry}>Add</button>
              <button onClick={handleAddMoreIndustry}>Add More</button>
            </div>

          </div>
        </div>
      )}


    </Container>
  );
};
export default CandidateListing;